import type { IconSvgObject } from './types';

const Undo02Icon: IconSvgObject = [
  ["path", { d: "M3 3V9L9 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9999 21C16.9705 21 20.9999 16.9706 20.9999 12C20.9999 7.02944 16.9705 3 11.9999 3C8.66867 3 5.76012 4.80989 4.20398 7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Undo02Icon;
